export default __webpack_public_path__ + "static/media/flag-iraq.10c2bd8c.svg";